import React from "react";
import intl from "react-intl-universal";
import {observer} from "mobx-react-lite";
import {useRootStore, useUserState} from "@stores/AppStateContext";

import {UserAvatar} from "../../../../components/Avatar/Avatar";
import {getFullName} from "../../../../../utils/userHelper";
import {
    ActiveUsers as ActiveUsersView,
    ActiveUsersCount,
    ActiveUsersItem
} from "../../../../components/ActiveUsers/ActiveUsers";

import {getDocPath} from "@stores/ActivityProvider";

import {screenSizeProvider} from "@stores/ScreenSizeProvider";

export const ActiveUserCount = observer(() => {
    const rootStore = useRootStore();
    const userState = useUserState();
    const selectedNode = rootStore.view.workspace!.selected;

    if (!selectedNode) {
        return null;
    }

    const currentDocActivity = userState!.activityProvider!.activity.get(getDocPath(rootStore.view.workspace!.id, selectedNode.id));
    const activeUsersCount = currentDocActivity ? currentDocActivity.size : 0;

    return <ActiveUsersCount count={activeUsersCount}/>;
});

export const ActiveUsers = observer(() => {
    const isMobile = screenSizeProvider.view !== 'desktop';
    const rootStore = useRootStore();
    const userState = useUserState();
    const selectedNode = rootStore.view.workspace!.selected;

    if (!selectedNode) {
        return null;
    }

    const activity = userState!.activityProvider!.activity;
    const currentDocActivity = activity.get(getDocPath(rootStore.view.workspace!.id, selectedNode.id)) || new Set();
    const users: ActiveUsersItem[] = Array.from(currentDocActivity)
        .flatMap((userId: string): ActiveUsersItem[] => {
            const user = userState!.usersDS.users.get(userId);
            if (!user) {
                return [];
            }

            return [{
                id: userId,
                name: getFullName(user),
                avatar: (
                    <UserAvatar
                        user={user}
                        size={36}
                    />
                ),
            }];
        });

    return (
        <ActiveUsersView
            users={users}
            activeUsersCount={currentDocActivity.size}
            showHeader={!isMobile}
            headerTitle={intl.get('activeUsers.sub_header').d('Users currently viewing this Page:')}
            emptyText={intl.get('activeUsers.empty').d('No users are currently viewing this page.')}
            showEmpty={currentDocActivity.size === 0 && isMobile}
        />
    );
});
